export const iconFontAwesomeMapsScaleBalanced = (
	<i className="fa-solid fa-scale-balanced"></i>
);
